import { render, staticRenderFns } from "./tab.components.vue?vue&type=template&id=484ee4db"
import script from "./tab.components.vue?vue&type=script&lang=js"
export * from "./tab.components.vue?vue&type=script&lang=js"
import style0 from "./tab.components.vue?vue&type=style&index=0&id=484ee4db&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports